import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import ServiceIcon from "./ServiceIcon";

export default function ServiceCard({ service, suffix = "", headingLevel = "h3" }) {
  const Heading = headingLevel;
  return (
    <Link
      to={`/services/${service.slug}`}
      className="card card-hover group h-full p-6 flex flex-col"
      data-testid={`service-card-${service.slug}`}
    >
      <div className="flex items-start justify-between">
        <span className="icon-pop grid h-12 w-12 place-items-center rounded-2xl bg-[var(--sage-tint)] text-[var(--sage)]">
          <ServiceIcon name={service.icon} />
        </span>
        <ArrowUpRight className="h-5 w-5 text-[var(--body)] opacity-40 group-hover:opacity-100 group-hover:text-[var(--sage)] transition" />
      </div>
      <Heading className="mt-5 text-xl">
        {service.title}
        {suffix}
      </Heading>
      <p className="mt-1 text-xs font-semibold uppercase tracking-wider text-[var(--sage)]">{service.subtitle}</p>
      <p className="mt-3 text-sm leading-relaxed text-body">{service.short}</p>
    </Link>
  );
}
